module.exports = __webpack_public_path__ + "static/media/megafoon.faf27f77.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/megafoon.svg
// module id = 624
// module chunks = 0